import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBillingUsage, setLastMonthBillingUsage, clearBillingUsage } from '@Redux/billingUsage/billingUsageActions';

export const useReduxBillingUsage = () => {

    const dispatch = useDispatch();
    const usage = useSelector((state) => state.billingUsage.currentBillingUsage);
    const lastMonthUsage = useSelector((state) => state.billingUsage.lastMonthBillingUsage);

    const setCurrentBillingUsage = useCallback(
        (usageData) => dispatch(setBillingUsage(usageData)),
        [dispatch]
    );

    const setCurrentLastMonthBillingUsage = useCallback(
        (usageData) => dispatch(setLastMonthBillingUsage(usageData)),
        [dispatch]
    );

    const clearCurrentBillingUsage = useCallback(
        () => dispatch(clearBillingUsage()),
        [dispatch]
    );

    const isAtLimit =
        !!usage &&
        usage.planLimitSnapshot > 0 &&
        usage.ticketCount >= usage.planLimitSnapshot;

    const isOverLimit = isAtLimit;

    let isCreationBlocked = false;
    if (isAtLimit) {
        if (usage.ticketLimitMode === 'hard') {
            isCreationBlocked = true;
        } else if (usage.ticketLimitMode === 'soft') {
            isCreationBlocked = (lastMonthUsage?.overageCount ?? 0) > 0;
        }
    }

    return {
        usage,
        lastMonthUsage,
        isOverLimit,
        isCreationBlocked,
        setCurrentBillingUsage,
        setCurrentLastMonthBillingUsage,
        clearCurrentBillingUsage,
    };
};
